// Slide decks associated with Introduction to Computer Science (ICS) sprint 4
import { xyz_n_1of4 } from './SL00000Sprint00TTR'
import { list20000Sprint03 } from '../ActivityLists/AL20000Sprint03'
import { list20000Sprint04 } from '../ActivityLists/AL20000Sprint04'
import { tUnderConstruction } from './SL00000Sprint00'
import { agendaSlide, basicSlide, bulletListSlide, orderedListSlide, tPrework, tRecap, tPreworkWithLogo, basicSlideWithLogo } from './SLSprint00'
import { makeSlideDeck, tLab, tReviewDemoSchedule } from './SL00000Sprint00'
import { checklistAnnouncementsPreworkAndAgenda } from './SL00000Sprint00'
import { submissionPercentage } from './SLSprint00'
import { completeDeck } from './SL00000Sprint00'
import { sprintDemos, sprintDemosIntro, demoAssignment } from './SLSprint00'

const sprint = 4
const activityList = () => { return list20000Sprint04(sprint) }
const activityListPrevious = () => { return list20000Sprint03(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ics_4_1of4 = () => { return xyz_n_1of4(null, null, sprintAndActivityLists, null) }

// Session 2 of 4: Thursday
const ics_4_2of4 = () => { return [ tUnderConstruction ] }

// Session 3 of 4: Tuesday
export const ics_4_3of4_PAaA = {
	'prework':[
		`Make your initial Discussion ${sprint} post`,
		'Complete through activity 11 prior to next class', 
		'Focus on reading Engineering Software as a Service Chapter 2 and the associated lecture',
		`Be prepared for Quiz ${sprint}` ],
	'announcements':[
		`Your initial Discussion ${sprint} post was due two days ago`,
		`All sprint ${sprint} activities and assignments due Sunday!`,
		'Reminder that next week is asynchronous remote**' ],
	'agenda':[
		'Sprint Progress Polling',
		'Review Sprint Planning',
		'Review Demo Schedule',
		'Prework for Next Class' ]
}

const ics_4_3of4x = (pAaA, pAaANext, saals) => {
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprintAndActivityLists.sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			`Different in that we have Spring Break during the sprint`,
			`Different in that we will have four weeks to complete all sprint ${sprint} activities and assignments`,
			`Different in that Discussion Board ${sprint} will be an individual activity`,
			`Different in that we will have sprint ${sprint-1} Demos and Retrospectives next Thursday`,
			'Different in that this week will be asynchronous and remote',
			`Different in that our sprint ${sprint} classes will be remote via Zoom**` ])
	}
	const prework = () => { return tPreworkWithLogo('Prework For Today', pAaA.prework, saals.sprint, saals.activityList) }
	const announcements =  () => { return basicSlideWithLogo( 'Announcements', ['Let’s stay focused on sprint planning today']) }
	const agenda = () => { return agendaSlide(pAaA.agenda) }

	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list, syllabus, and assignments together.' ])
	}
	const upcomingChanges = () => {
		return bulletListSlide('Upcoming Changes to the Course Structure', 
			'Course structure:', [
			'Sprint 4: Mar 09 through Mar 15: online synchronous',
			'Sprint 4: Mar 16 through Mar 22: online synchronous',
			'Sprint 4: Mar 23 through Mar 29: online synchronous',
			'Sprint 5: Mar 30 through Apr 05 (ongoing): In-person synchronous' ])
	}
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda) }

	return makeSlideDeck([ prework, announcements, agenda, sprintPlanningExpectations, activitiesReview, tReviewDemoSchedule, upcomingChanges, preworkNext, recap, tLab ])
}
const ics_4_3of4 = () => { return ics_4_3of4x(ics_4_3of4_PAaA, ics_4_4of4_PAaA, sprintAndActivityLists) }

// Session 4 of 4: Thursday
/*
export const theHumbleTextFileName = 'The Humble Text File'
export const theHumbleTextFile = () => {
	return bulletListSlide(`${theHumbleTextFileName}`, 
		'Let’s explore Binary Values and the Data Representation of text files including:', [
		'ASCII Text Files', 
		'Unicode',
		'UTF-16 and UTF-8 ',
		'What is a locale',
		'What is received when a US-English ASCII email is sent to a CA-French recipient?'])
}
*/

const xyz_4_4of4 = (pAaA, pAaANext, saals, metricsSubmissionPercentage, retrospective ) => {
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(pAaA, saals.sprint, saals.activityList)

	const metrics = () => {
		return basicSlide(`Sprint ${saals.sprint-1} Metrics`, [
			`Let’s take a minute and review our Sprint ${saals.sprint-1} Submission Percentage class metric.` ])
	}
	// Todo: Consider adding the pretty slides back into slide deck for Demos and Retrospectives. 

	const retrospectiveBreakout = () => {
		return orderedListSlide('Breakout Session for Team Retrospective', 
			'As a scrum team consider:', [
			`How does your team feel about sprint ${saals.sprint-1} now that it is over`,
			`What could be done to make sprint ${saals.sprint-1} or the class overall better or more manageable`,
			'What improvements should we make as a class, team, or individual going forward' ])
	}
	const sprintPlanningQA = () => {
		return orderedListSlide('Sprint Planning Q&A', 
			`Are you clear on what’s expected in sprint 1?`, [])
	}
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda.slice(1))}

	return completeDeck(slideDeck, [ tReviewDemoSchedule, sprintDemosIntro, sprintDemos, demoAssignment, metrics,
		metricsSubmissionPercentage, retrospective, retrospectiveBreakout, sprintPlanningQA, preworkNext, recap, tLab ])
}

const ics_4_4of4_PAaA = {
	'prework':[
		'Complete through activity 11 prior to next class', 
		'Be prepared for Demos and Retrospectives',
		'Be prepared for Lab' ],
	'announcements':[
		`All sprint ${sprint} activities and assignments due Sunday!`,
		'Next week will be asynchronous remote**' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Sprint ${sprint} Planning Q&A`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class',
		'Lab' ]
}
const ics_4_4of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:24, submitted:22 },
			{ name: 'Quiz', due:24, submitted:23 },
			{ name: 'Lab', due:24, submitted:23 },
			{ name: 'Reflection', due:24, submitted:23 }])
	} 
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`The Metrics do not fully reflect reality in that the metrics only include students who participate in some way',
			'Please, please, please submit something for each assignment`,
			`All sprint ${sprint-1} assignments are graded and posted`, 
			'Be **sure** to put something in for each question so that I can give you at least a point or two',
			`If you are not where you want to be in the class after sprint ${sprint-1}, let’s set up a time to talk.` ])
	}

	return xyz_4_4of4(ics_4_4of4_PAaA, ics_4_7of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
}

// Session 1 of 4: Tuesday
const ics_4_7of4_PAaA = {
	'prework':[
		'Complete through activity 11 prior to next class' ],
	'announcements':[
		'Thursday will be asynchronous remote**',
		'Utilize Thursday to complete your Midterm Exam', '', 
		'All sprint 4 activities and assignments due Sunday!', '',
		'Next Tuesday is sprint 5 planning with in person attendance required'
	],
	'agenda':[
		`Final sprint ${sprint} activity list and assignment Q&A`,
		'Prework for Next Class', 
		'Lab']
}






export const ics_4_slidedeckTTR = [ ics_4_1of4, ics_4_2of4, ics_4_3of4, ics_4_4of4 ]